import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar w-100" }

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'ToolBar',
  props: {
  reportName: String,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, { reportName: __props.reportName }, null, 8, ["reportName"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spacer" }, null, -1))
  ]))
}
}

})